import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField, MenuItem, RadioGroup, FormControlLabel, Radio, Button, FormControl, FormHelperText } from '@material-ui/core';
import { clone, newId, timeFormat2 } from '../../../../../common/utils';
import { ADD, CLIENT, EDIT, ERR, globalData, TEXT, VIEW } from '../../../../../common/common';

const Root = styled(Box)({
    width: '100%',
})

class PanelClient extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {
                "P.F.Name": "",
                "P.L.Name": "",
                "P.DOB": new Date(),
                "P.SSN.L4": "",
                "P.H.Pho": "",
                "P.W.Pho": "",
                "P.Em": "",
                "P.SEX": "",
                "P.F.L.N.I.": "",
                "P.H.Addr.": {
                    "phone": "",
                    "unit": "",
                    "street": "",
                    "city": "",
                    "country": "",
                    "state": "",
                    "zipcode": "",
                },
            },
            stateData: ["CN", "US"],
            panelState: ADD,
            showMsg: false
        }
        this.handleAdd = this.handleAdd.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }
    render() {
        const {
            data,
            panelState,
            stateData
        } = this.state;
        const content = () => {
            if (panelState === VIEW) {
                return clientView()
            } else if (panelState === EDIT || panelState === ADD) {
                return clientEdit()
            }
        }
        const clientView = () => {
            return <div className="panel-wapper v v-r">
                <div className="flow">
                    <div className="text-wapper">
                        <div className="text-title">Principal/Client Full Legal Name</div>
                        <div>{data["P.F.Name"]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Principal/Client Last Name</div>
                        <div>{data["P.L.Name"]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Principal/Client Initial Name</div>
                        <div>{data["P.F.L.N.I."]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Principal Gender</div>
                        <div>{data["P.SEX"]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Principal Date of Birth</div>
                        <div>{data["P.DOB"]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Last 4 Digits of Principal Social Security Number</div>
                        <div>{data["P.SSN.L4"]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Principal Choose The Country</div>
                        <div>{data["P.H.Addr."]["country"]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Principal Street</div>
                        <div>{data["P.H.Addr."]["street"]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Principal City</div>
                        <div>{data["P.H.Addr."]["city"]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Principal State</div>
                        <div>{data["P.H.Addr."]["state"]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Principal Zip Code</div>
                        <div>{data["P.H.Addr."]["zipcode"]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Principal Home Phone</div>
                        <div>{data["P.H.Pho"]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Principal Work Phone (Optional)</div>
                        <div>{data["P.W.Pho"]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Principal Email (Optional)</div>
                        <div>{data["P.Em"]}</div>
                    </div>
                </div>
                <div>
                    <Button size="small" color="primary" onClick={this.handleEdit}>Edit</Button>
                </div>
            </div>
        }
        const clientEdit = () => {
            return <div className="panel-wapper v v-r">
                <div className="flow">
                    <div className="text-wapper">
                        <div className="text-title">Principal/Client Full Legal Name</div>
                        <TextField
                            disabled={this.isDisabled()}
                            className="text-field"
                            value={data["P.F.Name"]}
                            onChange={e => this.handleChange(e, 'P.F.Name')}
                            margin="dense"
                            variant="outlined"
                            error={this.validator(ERR, "P.F.Name")}
                            helperText={this.validator(TEXT, "P.F.Name")}
                        />
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Principal/Client Last Name</div>
                        <TextField
                            disabled={this.isDisabled()}
                            className="text-field"
                            value={data["P.L.Name"]}
                            onChange={e => this.handleChange(e, 'P.L.Name')}
                            margin="dense"
                            variant="outlined"
                            error={this.validator(ERR, "P.L.Name")}
                            helperText={this.validator(TEXT, "P.L.Name")}
                        />
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Principal/Client Initial Name</div>
                        <TextField
                            disabled={this.isDisabled()}
                            className="text-field"
                            value={data["P.F.L.N.I."]}
                            onChange={e => this.handleChange(e, 'P.F.L.N.I.')}
                            margin="dense"
                            variant="outlined"
                            error={this.validator(ERR, "P.F.L.N.I.")}
                            helperText={this.validator(TEXT, "P.F.L.N.I.")}
                        />
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Principal Gender</div>
                        <FormControl error={this.validator(ERR, "P.SEX")} >
                            <RadioGroup
                                row
                                value={data["P.SEX"]}
                                onChange={e => this.handleChange(e, 'P.SEX')}
                            >
                                <FormControlLabel disabled={this.isDisabled()} value="male" control={<Radio color="primary" />} label="Male" />
                                <FormControlLabel disabled={this.isDisabled()} value="female" control={<Radio color="primary" />} label="Female" />
                            </RadioGroup>
                            <FormHelperText>{this.validator(TEXT, "P.SEX")}</FormHelperText>
                        </FormControl>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Principal Date of Birth</div>
                        <TextField
                            type="date"
                            disabled={this.isDisabled()}
                            className="text-field"
                            value={data["P.DOB"]}
                            onChange={e => this.handleChange(e, 'P.DOB')}
                            margin="dense"
                            variant="outlined"
                            error={this.validator(ERR, "P.DOB")}
                            helperText={this.validator(TEXT, "P.DOB")}
                        />
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Last 4 Digits of Principal Social Security Number</div>
                        <TextField
                            disabled={this.isDisabled()}
                            className="text-field"
                            value={data["P.SSN.L4"]}
                            onChange={e => this.handleChange(e, 'P.SSN.L4')}
                            margin="dense"
                            variant="outlined"
                            error={this.validator(ERR, "P.SSN.L4")}
                            helperText={this.validator(TEXT, "P.SSN.L4")}
                        />
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Principal Choose The Country</div>
                        <TextField
                            disabled={this.isDisabled()}
                            select
                            className="text-field"
                            value={data["P.H.Addr."]["country"]}
                            onChange={e => this.handleChange(e, 'country', "P.H.Addr.")}
                            margin="dense"
                            variant="outlined"
                            error={this.validator(ERR, "P.H.Addr.", "country")}
                            helperText={this.validator(TEXT, "P.H.Addr.", "country")}
                        >
                            {stateData.map((row, index) => (
                                <MenuItem key={index} value={row}>
                                    {row}
                                </MenuItem>
                            ))}
                        </TextField>
                    </div>
                    {unitView("P.H.Addr.")}
                    <div className="text-wapper">
                        <div className="text-title">Principal Street</div>
                        <TextField
                            disabled={this.isDisabled()}
                            className="text-field"
                            value={data["P.H.Addr."]["street"]}
                            onChange={e => this.handleChange(e, 'street', "P.H.Addr.")}
                            margin="dense"
                            variant="outlined"
                            error={this.validator(ERR, "P.H.Addr.", "street")}
                            helperText={this.validator(TEXT, "P.H.Addr.", "street")}
                        />
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Principal City</div>
                        <TextField
                            disabled={this.isDisabled()}
                            className="text-field"
                            value={data["P.H.Addr."]["city"]}
                            onChange={e => this.handleChange(e, 'city', "P.H.Addr.")}
                            margin="dense"
                            variant="outlined"
                            error={this.validator(ERR, "P.H.Addr.", "city")}
                            helperText={this.validator(TEXT, "P.H.Addr.", "city")}
                        />
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Principal State</div>
                        <TextField
                            disabled={this.isDisabled()}
                            className="text-field"
                            value={data["P.H.Addr."]["state"]}
                            onChange={e => this.handleChange(e, 'state', "P.H.Addr.")}
                            margin="dense"
                            variant="outlined"
                            error={this.validator(ERR, "P.H.Addr.", "state")}
                            helperText={this.validator(TEXT, "P.H.Addr.", "state")}
                        />
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Principal Zip Code</div>
                        <TextField
                            disabled={this.isDisabled()}
                            className="text-field"
                            value={data["P.H.Addr."]["zipcode"]}
                            onChange={e => this.handleChange(e, 'zipcode', "P.H.Addr.")}
                            margin="dense"
                            variant="outlined"
                            error={this.validator(ERR, "P.H.Addr.", "zipcode")}
                            helperText={this.validator(TEXT, "P.H.Addr.", "zipcode")}
                        />
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Principal Home Phone</div>
                        <TextField
                            disabled={this.isDisabled()}
                            className="text-field"
                            value={data["P.H.Pho"]}
                            onChange={e => this.handleChange(e, 'P.H.Pho')}
                            margin="dense"
                            variant="outlined"
                            error={this.validator(ERR, "P.H.Pho")}
                            helperText={this.validator(TEXT, "P.H.Pho")}
                        />
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Principal Work Phone (Optional)</div>
                        <TextField
                            disabled={this.isDisabled()}
                            className="text-field"
                            value={data["P.W.Pho"]}
                            onChange={e => this.handleChange(e, 'P.W.Pho')}
                            margin="dense"
                            variant="outlined"
                        />
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Principal Email (Optional)</div>
                        <TextField
                            disabled={this.isDisabled()}
                            className="text-field"
                            value={data["P.Em"]}
                            onChange={e => this.handleChange(e, 'P.Em')}
                            margin="dense"
                            variant="outlined"
                        />
                    </div>
                </div>
            </div>
        }
        const unitView = (key) => {
            if (data[key]["country"] === "CN") {
                return <div className="text-wapper">
                    <div className="text-title">Principal Unit</div>
                    <TextField
                        disabled={this.isDisabled()}
                        className="text-field"
                        value={data[key]["unit"]}
                        onChange={e => this.handleChange(e, 'unit', key)}
                        margin="dense"
                        variant="outlined"
                        error={this.validator(ERR, key, "unit")}
                        helperText={this.validator(TEXT, key, "unit")}
                    />
                </div>
            }
        }
        return (
            <Root>
                {content()}
            </Root>
        )
    }
    componentDidMount() {
        this.initData();
    }
    componentDidUpdate(prevProps) {
        if (this.props.dataINFO !== prevProps.dataINFO) {
            const data = this.props.dataINFO;
            if (data && this.props.isAdd) {
                data["P.DOB"] = timeFormat2(data["P.DOB"]);
                let panelState = ADD;
                this.setState(() => ({
                    data,
                    panelState
                }))
            }
        }
    }
    initData() {
        const { dataINFO, isAdd } = this.props;
        let data = {};
        let panelState = "";
        if (isAdd) {
            panelState = ADD;
            data = {
                "P.F.Name": "",
                "P.L.Name": "",
                "P.DOB": timeFormat2(new Date()),
                "P.SSN.L4": "",
                "P.H.Pho": "",
                "P.W.Pho": "",
                "P.Em": "",
                "P.SEX": "",
                "P.F.L.N.I.": "",
                "P.H.Addr.": {
                    "phone": "",
                    "unit": "",
                    "street": "",
                    "city": "",
                    "country": "",
                    "state": "",
                    "zipcode": "",
                },
                "type": CLIENT
            }
        } else {
            panelState = EDIT;
            data = dataINFO ? clone(dataINFO) : globalData.dataINFO;
            data["P.DOB"] = timeFormat2(data["P.DOB"]);
        }
        this.setState(() => ({
            data,
            panelState
        }))
    }
    handleAdd() {
        this.setState({
            panelState: EDIT
        })
    }
    handleEdit() {
        this.setState({
            panelState: EDIT
        })
    }
    handleSave(callback = null) {
        const { data } = this.state;
        const { isAdd } = this.props;
        this.setState({
            showMsg: true
        }, () => {
            if (this.doNext()) {
                if (callback) callback(true);
                this.extractClientToGlobal(data)
                this.props.updateInfoData(data, isAdd);
            } else {
                if (callback) callback(false);
            }
        })
    }
    handleCancel() {
        this.setState({
            panelState: VIEW
        })
    }
    extractClientToGlobal(infoData) {
        const clientInfo = {};
        clientInfo[".CHO.Em."] = infoData["P.Em"];
        clientInfo[".CHO.N."] = infoData["P.F.Name"];
        clientInfo[".CHO.AddrNPho"] = infoData["P.H.Addr."];
        clientInfo[".CHO.Addr"] = infoData["P.H.Addr."];
        clientInfo["P.H.Pho"] = infoData["P.H.Pho"];
        clientInfo["P.W.Pho"] = infoData["P.W.Pho"];
        clientInfo[".CHO.R.C."] = (infoData["P.SEX"] === "male") ? "Spouse's;Husband" : "Spouse's;Wife";
        clientInfo["rc"] = "Spouse's";
        clientInfo["relation"] = (infoData["P.SEX"] === "male") ? "Husband" : "Wife";
        clientInfo["type"] = CLIENT;
        globalData.clientInfo = clientInfo;
    }
    handleChange(e, name, addrKey) {
        const value = e.target.value;
        const { data } = this.state;
        data[name] = value;
        if (name === "phone" || name === "unit"
            || name === "street" || name === "city"
            || name === "country" || name === "state"
            || name === "zipcode") {
            data[addrKey][name] = value;
        } else if (name === "P.H.Pho") {
            data["P.H.Addr."]["phone"] = value;
        } else if (name === "S.H.Pho") {
            data["S.H.Addr."]["phone"] = value;
        } else if (name === "P.F.Name") {
            data["P.L.Name"] = this.splitName(value);
            data["P.F.L.N.I."] = this.splitInitial(value);
        } else if (name === "S.F.Name") {
            data["S.L.Name"] = this.splitName(value);
            data["S.F.L.N.I."] = this.splitInitial(value);
        } else if (name === "P.DOB") {
            console.log(value)
        }
        this.setState(() => ({
            data
        }));
    }
    splitName(str) {
        let strArr = str.split(" ");
        if (strArr.length >= 2) {
            return strArr[strArr.length - 1];
        } else {
            return "";
        }
    }
    splitInitial(str) {
        let strArr = str.split(" ");
        if (strArr.length >= 2) {
            let initial = "";
            for (const value of strArr) {
                initial += (value.slice(0, 1));
            }
            return initial.toUpperCase();
        } else {
            return "";
        }
    }
    doNext() {
        const { data } = this.state;
        let canNext = true;
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                if (key === "P.H.Addr.") {
                    canNext = this.verifyAddrValue(data[key]);
                    if (canNext) {
                        continue;
                    }
                } else if (key === "P.Em" || key === "P.W.Pho" || key === "S.F.Name" ||
                    key === "S.L.Name" || key === "S.DOB" || key === "S.SSN.L4" ||
                    key === "S.H.Pho" || key === "S.W.Pho" || key === "S.Em" ||
                    key === "S.F.L.N.I." || key === "S.H.Addr.") {
                    continue;
                }
                if (data[key] === "" || canNext === false) {
                    return false;
                }
            }
        }
        return true;
    }
    verifyAddrValue(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                if (key === "unit" && obj[key] === "") {
                    if (obj["country"] === "US") {
                        continue;
                    }
                }
                if (key === "phone") {
                    continue;
                }
                if (obj[key] === "") {
                    return false;
                }
            }
        }
        return true;
    }
    validator(type, name1, name2) {
        const { data, showMsg } = this.state;
        if (showMsg) {
            const value = name2 ? data[name1][name2] : data[name1];
            if (type === ERR) {
                return value ? false : true;
            } else {
                return value ? "" : "This field is required."
            }
        } else {
            const value = type === ERR ? false : "";
            return value;
        }
    }
    isDisabled() {
        return false
        // const { state } = this.props;
        // if (state === ADD) {
        //     return false;
        // } else if (state === VIEW) {
        //     return true;
        // } else if (state === EDIT) {
        //     return false;
        // }
    }
}

export default PanelClient;